module.exports = __webpack_public_path__ + "img/wild_comming.b3bc1f88.png";